export * from './TagIcon';
export * from './TagIcon16Light';
export * from './TagIcon16Regular';
export * from './TagIcon16Solid';
export * from './TagIcon20Light';
export * from './TagIcon20Regular';
export * from './TagIcon20Solid';
export * from './TagIcon24Regular';
export * from './TagIcon24Solid';
export * from './TagIcon32Regular';
export * from './TagIcon64Regular';
